

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ScheduleInterface, ScheduleData } from './types';

@Component
export default class ScheduleComponent
  extends Vue
  implements ScheduleInterface
{
  @Prop({ type: String, default: 'Расписание' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly schedule!: Array<ScheduleData>;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/scheduleblock/ScheduleComponent.vue